import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import DeleteIcon from '@mui/icons-material/Delete';
import {Button, Box} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import deleteAreaShape from '../../../actions/area/delete-area-shape';
import selectAreaShape from '../../../actions/area/select-area-shape';
import {areaSelector} from '../../../selectors/area';

const useStyles = makeStyles({
  root: {
    marginTop: '20px'
  }
});

const AreaShapeDeleteButton = (): JSX.Element | null => {
  const hasArea = Boolean(useSelector(areaSelector)?.shape);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();

  const handleDeleteButton = (): void => {
    dispatch(deleteAreaShape());
    navigate('/config/area');
  };
  

  return (
    <Button
      className={classes.root}
      disableElevation
      disableRipple
      disabled={!hasArea}
      variant="contained"
      color="primary"
      onClick={(): void => {
        handleDeleteButton();
      }}>
      <Box
        width="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center">
        <div>Ausweisung zurücksetzen</div>
        <DeleteIcon />
      </Box>
    </Button>
  );
};

export default AreaShapeDeleteButton;
